import { ChevronDown } from 'lucide-react'
import { cn } from '../utils/cn'

export default function BrandDropdown({
  brandName,
  brandId,
  activeDropdown,
  setActiveDropdown,
  socialLinks,
  doesHaveUnderline = false,
  doesHaveGradient = true,
  children = null,
  textSize = 'text-base',
  className = '',
}) {
  return (
    <div className="relative">
      <button
        type="button"
        onClick={() =>
          setActiveDropdown(activeDropdown === brandId ? null : brandId)
        }
        className={cn(
          'text-white hover:cursor-pointer flex items-center justify-between w-full gap-1',
          className,
        )}
      >
        <span
          className={cn(
            'h-fit w-fit text-nowrap group-hover:bg-gradient-to-r group-hover:from-[#4B3BDB] group-hover:via-[#A002CB] group-hover:to-[#FC0021] group-hover:bg-clip-text group-hover:text-transparent relative',
            textSize,
            activeDropdown === brandId &&
              doesHaveGradient &&
              'bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] bg-clip-text text-transparent relative',
          )}
        >
          {brandName}
          {doesHaveUnderline && (
            <span
              className={cn(
                'absolute h-px w-0 bottom-0 left-0 bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] group-hover:w-full transition-all duration-200',
                activeDropdown === brandId &&
                  'w-full',
              )}
            />
          )}
        </span>
        <ChevronDown
          className={cn('size-5', activeDropdown === brandId && 'rotate-180')}
        />
      </button>
      {activeDropdown === brandId && socialLinks && (
        <div className="mt-2 py-2 rounded-md shadow-lg">
          <div className="flex flex-row gap-3 items-center">
            <a
              target="_blank"
              href={socialLinks.facebook || '#'}
              rel="noreferrer"
            >
              <div className="bg-[#fff] rounded-full p-1.5 hover:scale-110 duration-100">
                <img
                  src="/assets/icones/icone-facebook.svg"
                  alt="arrow"
                  className="w-4 h-4"
                />
              </div>
            </a>
            <a
              target="_blank"
              href={socialLinks.instagram || '#'}
              rel="noreferrer"
            >
              <div className="bg-[#fff] rounded-full p-1.5 hover:scale-110 duration-100">
                <img
                  src="/assets/icones/icone-instagram.svg"
                  alt="arrow"
                  className="w-4 h-4"
                />
              </div>
            </a>
            <a
              target="_blank"
              href={socialLinks.linkedin || '#'}
              rel="noreferrer"
            >
              <div className="bg-[#fff] rounded-full p-1.5 hover:scale-110 duration-100">
                <img
                  src="/assets/icones/icone-linkedin.svg"
                  alt="arrow"
                  className="w-4 h-4"
                />
              </div>
            </a>
          </div>
        </div>
      )}
      {activeDropdown === brandId && !socialLinks && (
        <div className="mt-3">{children}</div>
      )}
    </div>
  )
}
